/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment-timezone';
import DayView from './DayView';
import WeekView from './WeekView';
import ShimmerContent from './ShimmerContent';
import EntryPointContent from './EntryPointContent';
import {
  setActiveModal,
  getAssignedWorkoutItemsForCalendarByDate,
  getAssignedWorkoutItemsForAthleteByDate,
  getRecurringWorkoutsByDate,
  fetchNonDateBasedProgramItemsByDayRange,
  setSelectedReduxNonDateBasedProgram,
  setSelectedReduxCalendar,
  setSelectedReduxAthlete,
  clearBeforeRecurringCalendarItems,
  clearAfterRecurringCalendarItems,
  setSelectedDate,
  clearCalendarItems,
  clearNonDateBasedProgramItems,
  setSelectedProgramDayNumber,
} from '../../ducks/calendarActions';

const Container = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: visible;
`;

const ExerciseContainer = styled('div')`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  // height: ${(props) => props.setHeightTo100 && '100%'};
`;

const SelectCalendarContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const SelectCalendarText = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  margin-top: 15px;
  margin-bottom: 15px;
`;

const SelectCalendarButton = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  width: auto;
  height: 32px;
  padding: 6px 16px 6px 16px;
  background: #444444;
  border: 2px solid #444444;
  color: white;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  user-select: none;
`;

const CreateNewCalendarButton = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  width: auto;
  height: 32px;
  padding: 6px 16px 6px 16px;
  background: white;
  border: 2px solid #444444;
  color: #444444;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  user-select: none;
`;

const shimmerCount = [1, 2, 3, 4, 5, 6, 7, 8, 9];

const CalendarPanel = ({ scrollContainerRef }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const onBeforeCapture = useSelector((state) => state.calendar.data.onBeforeCapture);
  const selectedReduxCalendar = useSelector((state) => state.calendar.data.selectedReduxCalendar);
  const selectedReduxNonDateBasedProgram = useSelector(
    (state) => state.calendar.data.selectedReduxNonDateBasedProgram,
  );
  const selectedReduxAthlete = useSelector((state) => state.calendar.data.selectedReduxAthlete);
  const isCalendarItemsLoading = useSelector((state) => state.calendar.ui.isCalendarItemsLoading);
  const isSavedItemsLoading = useSelector((state) => state.calendar.ui.isSavedItemsLoading);
  const viewType = useSelector((state) => state.calendar.data.viewType);
  const programType = useSelector((state) => state.calendar.data.programType);

  /** Data fetching related selectors */
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const shouldUpdateRecurring = useSelector((state) => state.calendar.data.shouldUpdateRecurring);

  useEffect(() => {
    /** we need to make sure we clear the selected athlete or calendar
     * when we switch into program library mode because a lot of logic is tied to a chosen
     * athlete or calendar
     */
    if (programType === 'free-form-program') {
      dispatch(setSelectedReduxAthlete({}));
      dispatch(setSelectedReduxCalendar({}));
      /** also want to clear the calendar items so there is no confusion with
       * program items
       */
      dispatch(clearCalendarItems());
      /** need to clear recurring because recurring items don't exist in program library mode */
      dispatch(clearBeforeRecurringCalendarItems());
      dispatch(clearAfterRecurringCalendarItems());
      /** set selected date back to current date so user gets fresh start
       * when they switch back into calendar mode
       */
      dispatch(setSelectedDate(new Date()));
    } else if (programType === 'calendar') {
      /** same for when the programType is calendar, we need to clear
       * the selected nonDateBasedProgram
       * this will help us make sure useEffects aren't running when they shouldn't
       * when switching modes
       * Only clear if there's actually a program selected to avoid unnecessary dispatches
       */
      if (Object.keys(selectedReduxNonDateBasedProgram).length > 0) {
        dispatch(setSelectedReduxNonDateBasedProgram({}));
        /** we also want to clear the non date based program items
         * so there is no confusion with workout items
         */
        dispatch(clearNonDateBasedProgramItems());
      }
    }
  }, [
    programType,
    selectedReduxNonDateBasedProgram,
  ]);

  /** Data fetching logic moved from CalendarLayout */
  useEffect(() => {
    const reduxDate = moment(selectedDate);

    /** Calculate current month + next month days (x) */
    const currentMonthStart = reduxDate.clone().startOf('month');
    const nextMonthEnd = reduxDate.clone().add(1, 'month').endOf('month');
    const currentAndNextMonthDays = nextMonthEnd.diff(currentMonthStart, 'days') + 1; // +1 to include end day

    /** Calculate how many days we can fetch from previous month (y) such that x + y <= 69 */
    const maxPreviousDays = Math.max(0, 69 - currentAndNextMonthDays);

    /** Calculate the actual start date for fetching */
    const fetchStartDate = currentMonthStart.clone().subtract(maxPreviousDays, 'days');

    const firstDayMonth = fetchStartDate.format('YYYY-MM-DD');
    const lastDayMonth = nextMonthEnd.format('YYYY-MM-DD');

    /** Fetch main calendar items */
    if (Object.keys(selectedReduxCalendar).length && Object.keys(currentUser).length) {
      if (selectedReduxCalendar?.id) {
        dispatch(getAssignedWorkoutItemsForCalendarByDate(
          currentUser,
          firstDayMonth,
          lastDayMonth,
          selectedReduxCalendar.id,
        ));
      }
    } else if (Object.keys(selectedReduxAthlete).length && Object.keys(currentUser).length) {
      dispatch(getAssignedWorkoutItemsForAthleteByDate(
        currentUser,
        firstDayMonth,
        lastDayMonth,
        selectedReduxAthlete.id,
      ));
    }
  }, [
    selectedReduxCalendar,
    selectedReduxAthlete,
    currentUser,
    selectedDate,
  ]);

  /** Seperate useEffect to fetch data for non date based programs when in progam library view */
  useEffect(() => {
    const startDay = null;
    const endDay = null;
    /** Fetch non date based items */
    if (Object.keys(selectedReduxNonDateBasedProgram).length && Object.keys(currentUser).length) {
      if (selectedReduxNonDateBasedProgram?.id) {
        dispatch(fetchNonDateBasedProgramItemsByDayRange(
          currentUser.accountCode,
          selectedReduxNonDateBasedProgram.id,
          startDay,
          endDay,
        ));
      }
    }
  }, [
    selectedReduxNonDateBasedProgram,
    currentUser,
  ]);

  useEffect(() => {
    /** when we change the selected program we always need to reset
     * the selectedProgramDayNumber to 0
     */
    dispatch(setSelectedProgramDayNumber(0));
  }, [
    selectedReduxNonDateBasedProgram,
  ]);

  /** Separate effect for recurring workouts that only runs when needed
  and only in calendar based view */
  useEffect(() => {
    if (!shouldUpdateRecurring || !Object.keys(currentUser).length || programType === 'free-form-program') {
      return;
    }

    const reduxDate = moment(selectedDate);
    const firstDayMonth = reduxDate.clone().startOf('month').format('YYYY-MM-DD');
    const lastDayMonth = reduxDate.clone().endOf('month').format('YYYY-MM-DD');

    if (Object.keys(selectedReduxCalendar).length && selectedReduxCalendar?.id) {
      dispatch(getRecurringWorkoutsByDate(
        currentUser,
        firstDayMonth,
        lastDayMonth,
        selectedReduxCalendar.id,
      ));
    } else if (Object.keys(selectedReduxAthlete).length && selectedReduxAthlete?.id) {
      dispatch(getRecurringWorkoutsByDate(
        currentUser,
        firstDayMonth,
        lastDayMonth,
        selectedReduxAthlete.id,
        true,
      ));
    }
  }, [
    shouldUpdateRecurring,
    selectedReduxCalendar,
    selectedReduxAthlete,
    currentUser,
    selectedDate,
  ]);

  return (
    <Container setHeightTo100={onBeforeCapture}>
      <ExerciseContainer
        setHeightTo100={onBeforeCapture}
        viewType={viewType}
      >
        {viewType === 'dayView' ? (
          <>
            {(programType !== 'free-form-program' && !isCalendarItemsLoading) || (programType === 'free-form-program' && !isSavedItemsLoading) ? (
              <DayView scrollContainerRef={scrollContainerRef} />
            )
              : shimmerCount.map((_, i) => <ShimmerContent key={i} />)}
          </>
        ) : (
          <WeekView
            isWeekDayItemsLoading={(programType !== 'free-form-program' && isCalendarItemsLoading) || (programType === 'free-form-program' && (isSavedItemsLoading))}
          />
        )}
      </ExerciseContainer>
    </Container>
  );
};

CalendarPanel.propTypes = { };
export default CalendarPanel;
